import React from 'react';
import PropTypes from 'prop-types';
import DropdownItemComponent from './DropdownItemComponent';

class DropdownComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = { associations: [], open: false };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const { grouping } = this.props;
    const associations = [];
    associations.push({
      key: 0,
      value: grouping.Name,
      selected: true,
    });
    grouping.DataListAssociations.sort((a, b) => (a.Name > b.Name ? 1 : -1)).forEach((assoc) => {
      associations.push({
        key: assoc.ID,
        value: assoc.Name,
        selected: false,
      });
    });
    this.setState({ associations });
  }

  handleChange(key) {
    const { dropDownSearch, index } = this.props;
    const { open, associations } = this.state;
    if (open) {
      this.setState({ open: false });
      dropDownSearch(key, index);
    } else {
      this.setState({ open: true });
    }

    associations.forEach((_assoc) => {
      const assoc = _assoc;
      if (assoc.key === key) {
        assoc.selected = true;
      } else {
        assoc.selected = false;
      }
    });

    this.setState({ associations });
  }

  render() {
    const { associations, open } = this.state;
    const assocNodes = associations.map((assoc) => (
      <DropdownItemComponent key={assoc.key} association={assoc} handleChange={this.handleChange} />
    ));
    let classNames = 'evu-dropdown resetlist';
    if (open) {
      classNames += ' open';
    }
    return (
      <ul className={classNames}>
        {assocNodes}
      </ul>
    );
  }
}

DropdownComponent.propTypes = {
  grouping: PropTypes.shape({
    Active: PropTypes.bool.isRequired,
    DataListAssociations: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
    GroupOrder: PropTypes.number.isRequired,
    ID: PropTypes.number.isRequired,
    List: PropTypes.number.isRequired,
    Name: PropTypes.string.isRequired,
  }).isRequired,
  dropDownSearch: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};

DropdownComponent.displayName = 'DropdownComponent';

// Uncomment properties you need
// DropdownComponent.propTypes = {};
// DropdownComponent.defaultProps = {};

export default DropdownComponent;
